// ets_tracing: off
import { pipe } from "@effect-ts/core/Function";
import * as O from "@effect-ts/core/Option";
import * as T from "@effect-ts/core/Sync";
import { interpreter } from "../../HKT/index.mjs";
import { decoderApplyConfig, DecoderType, DecoderURI } from "../base/index.mjs";
import { fail, makeDecoder } from "../common/index.mjs";
export const decoderNewtypeInterpreter = /*#__PURE__*/interpreter()(() => ({
  _F: DecoderURI,
  newtypeIso: (iso, getDecoder, cfg) => env => (decoder => new DecoderType(decoderApplyConfig(cfg === null || cfg === void 0 ? void 0 : cfg.conf)(makeDecoder((u, c) => T.map_(decoder.validate(u, c), iso.get), "newtypeIso", (cfg === null || cfg === void 0 ? void 0 : cfg.name) || "NewtypeIso"), env, {
    decoder
  })))(getDecoder(env).decoder),
  newtypePrism: (prism, getDecoder, cfg) => env => (decoder => new DecoderType(decoderApplyConfig(cfg === null || cfg === void 0 ? void 0 : cfg.conf)(makeDecoder((u, c) => T.chain_(T.map_(decoder.validate(u, c), prism.getOption), O.fold(() => fail(u, c, `newtype doesn't satisfy prism conditions`), T.succeed)), "newtypePrism", (cfg === null || cfg === void 0 ? void 0 : cfg.name) || "NewtypePrism"), env, {
    decoder
  })))(getDecoder(env).decoder)
}));
//# sourceMappingURL=newtype.mjs.map